import { Col, Row } from "antd";
import { ReactNode, useCallback, useMemo } from "react";
import { Loader } from "../../../../../components/Loader";
import { EditProfile } from "./EditProfile/EditProfile";
import { useGetFullName } from "../../../../../lib/hooks/getFullName";
import { PortalAccess } from "./PortalAccess";
import dayjs from "../../../../../configs/dayjs";
import { useSelector } from "react-redux";
import USER_ROLES from "../../../../../types/UserRoles";

type ProfileTabProps = {
  userId: string | null;
  user: any;
  isEdit: boolean;
  roles: any[];
  isSaveClicked: boolean;
  isLoading: boolean;
  setIsSaveClicked: (value: boolean) => void;
  reloadData: () => void;
};

export const ProfileTab = ({
  userId,
  user,
  isEdit,
  roles,
  setIsSaveClicked,
  isSaveClicked,
  reloadData,
  isLoading,
}: ProfileTabProps) => {
  const { getFullName } = useGetFullName();

  const metaData = useSelector((state: any) => state.metaData);

  const fullName = useMemo(() => getFullName(user), [getFullName, user]);

  const lastLogin: string = useMemo(() => {
    if (user) {
      const { lastLoginDateTime } = user;

      return lastLoginDateTime
        ? dayjs(lastLoginDateTime).format("MM/DD/YYYY hh:mm A")
        : "-";
    }

    return "";
  }, [user]);

  const getRow = useCallback(
    (label: string, value: string): ReactNode => (
      <Row className="align-center mb-4">
        <Col span={8}>
          <span className="text-md title">{label}</span>
        </Col>
        <Col span={16}>
          <div className="elipsis" title={value}>
            {value}
          </div>
        </Col>
      </Row>
    ),
    [],
  );

  return (
    <>
      {isLoading ? (
        <Loader fontSize="64px" />
      ) : (
        <>
          {!isEdit ? (
            <Row className="d-block py-8 px-6">
              {getRow("Name", fullName)}
              {getRow("Username", user?.userName || "-")}
              {getRow("Email", user?.email)}
              {getRow("Phone", user?.phone)}
              {getRow("Role", user?.role)}
              {getRow("Last Login", lastLogin)}
              {user?.role === USER_ROLES.PORTAL_USER &&
                getRow(
                  "2FA Sending",
                  user?.twoFactorAuthenticationSendingType === 0
                    ? "Email"
                    : "SMS",
                )}
              {metaData.featureFlags.OnlineAccess && (
                <PortalAccess parentId={userId} parentStatus={user?.status} />
              )}
            </Row>
          ) : (
            <EditProfile
              user={user}
              roles={roles}
              isSaveClicked={isSaveClicked}
              setIsSaveClicked={setIsSaveClicked}
              reloadData={reloadData}
            />
          )}
        </>
      )}
    </>
  );
};
